import { ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

export const Slides = <T = unknown,>({
  size = 'md',
  items,
  children,
  isDisabled = false,
}: {
  size?: 'sm' | 'md' | 'lg';
  items?: T[];
  isDisabled?: boolean;
  children?: ReactNode | ((item: T, index: number) => ReactNode);
}) => {
  const config = {
    sm: {
      aspectRatio: 1.6,
      slidesPerView: 2.5,
      className: 'pt-1 pb-3 -mx-4',
      delay: 2943,
      padding: 16,
    },
    md: {
      aspectRatio: 2.1,
      slidesPerView: 1.6,
      className: 'py-3 -mx-4',
      delay: 5433,
      padding: 16,
    },
    lg: {
      aspectRatio: 2.5,
      slidesPerView: 1.4,
      className: 'pt-6',
      delay: 5433,
      padding: 0,
    },
  }[size];
  return (
    <div className={config.className}>
      <Swiper
        slidesOffsetBefore={config.padding}
        slidesOffsetAfter={config.padding}
        spaceBetween={12}
        slidesPerView={config.slidesPerView}
        loop
        autoplay={
          items && items.length > 3
            ? {
                delay: config.delay,
                disableOnInteraction: false,
              }
            : undefined
        }
        modules={[Autoplay]}
      >
        {!items && typeof children !== 'function' && children}
        {items?.map((item, index) => (
          <SwiperSlide
            key={index}
            style={{ aspectRatio: config.aspectRatio }}
            className={`rounded-xl overflow-hidden ${isDisabled ? ' swiper-no-swiping' : ''}`}
          >
            {typeof children === 'function'
              ? children?.(item, index)
              : children}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
